module.exports = __webpack_public_path__ + "assets/img/meeting-2026.6d96bb20.webp";